import { Dialog, Transition } from "@headlessui/react";
import React, {
  useState,
  Fragment,
  useRef,
  useContext,
  useEffect,
} from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import ptFlag from "../../assets/images/portugal.png";
import frFlag from "../../assets/images/franca.png";
import usFlag from "../../assets/images/usa.png";
import esFlag from "../../assets/images/ESP.png";
import i18n from "../../i18n";

// import { Container } from './styles';

function AlterarIdiomaModal({ cancelar, back }) {
  const cancelButtonRef = useRef(null);
  const { t } = useTranslation();
  const idiomaAtual = localStorage.getItem("i18nextLng");
 
  const [idiomaInicial, setIdiomaInicial] = useState(idiomaAtual);


  function mudarIdioma(e) {
    if (e.value == 2) {
      i18n.changeLanguage("fr");
      localStorage.setItem("i18nextLng", "fr");
      setIdiomaInicial({ value: 2, label: t("frances") });
    } else if (e.value == 1) {
      i18n.changeLanguage("pt");
      localStorage.setItem("i18nextLng", "pt");
      setIdiomaInicial({ value: 1, label: t("portugues") });
    } else if (e.value == 3) {
      i18n.changeLanguage("en");
      localStorage.setItem("i18nextLng", "en");
      setIdiomaInicial({ value: 3, label: t("ingles") });
    
    } else if (e.value == 4) {
      i18n.changeLanguage("es");
      localStorage.setItem("i18nextLng", "es");
      setIdiomaInicial({ value: 3, label: t("espanhol") });
    }
  }

  return (
    <Transition.Root show as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={() => cancelar()}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className=" p-14 relative dark:bg-gray-700 transform overflow-hidden rounded-[8px] bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white dark:bg-gray-700 px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="flex items-center justify-center">
                    <div className="flex flex-row justify-center">
                      <button
                        onClick={() => {
                          mudarIdioma({ value: 2, label: t("frances") });
                          cancelar(true)
                        }}
                        type="button"
                        className={`flex flex-col mr-5 items-center justify-center max-w-sm   rounded-xl border-gray-200 hover:bg-slate-400 shadow h-[80px] w-[80px] ${
                          idiomaAtual === "fr"  ? "bg-slate-400 border focus:ring-4 focus:outline-none" : "bg-white"
                        }`}
                      >
                        <img
                          width={"100%"}
                          style={{ padding: 10 }}
                          src={frFlag}
                        />
                      </button>
                      <button
                        onClick={() => {
                          mudarIdioma({ value: 1, label: t("portugues") });
                          cancelar(true)
                        }}
                        type="button"
                        className={`flex flex-col mr-5 items-center justify-center max-w-sm   rounded-xl border-gray-200 hover:bg-slate-400 shadow h-[80px] w-[80px] ${
                          idiomaAtual === "pt"  ? "bg-slate-400 border focus:ring-4 focus:outline-none" : "bg-white"
                        }`}
                      >
                        <img
                          width={"100%"}
                          style={{ padding: 8 }}
                          src={ptFlag}
                        />
                      </button>
                      <button
                        onClick={() => {
                          mudarIdioma({ value: 3, label: t("ingles") });
                          cancelar(true)
                        }}
                        type="submit"
                        className={`flex flex-col items-center justify-center max-w-sm   rounded-xl border-gray-200 hover:bg-slate-400 shadow h-[80px] w-[80px] ${
                          idiomaAtual === "en"  ? "bg-slate-400 border focus:ring-4 focus:outline-none" : "bg-white"
                        }`}
                      >
                        <img
                          width={"100%"}
                          style={{ padding: 8 }}
                          src={usFlag}
                        />
                      </button>
                      <button
                        onClick={() => {
                          mudarIdioma({ value: 4, label: t("espanhol") });
                          cancelar(true)
                        }}
                        type="submit"
                        className={`flex flex-col items-center justify-center max-w-sm   rounded-xl border-gray-200 hover:bg-slate-400 shadow h-[80px] w-[80px] ${
                          idiomaAtual === "es"  ? "bg-slate-400 border focus:ring-4 focus:outline-none" : "bg-white"
                        }`}
                      >
                        <img
                          width={"100%"}
                          style={{ padding: 8 }}
                          src={esFlag}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default AlterarIdiomaModal;
